import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/user/counts/user.counts.query.gql"
import type {
  UserStatusCountsQuery,
  UserStatusCountsQueryVariables,
} from "@/v2-backoffice-client/user/counts/__types__/user.counts.query"

type Options = QueryHookOptions<
  UserStatusCountsQuery,
  UserStatusCountsQueryVariables
>

export function useUserStatusCountsQuery(options?: Options) {
  return useQuery<UserStatusCountsQuery, UserStatusCountsQueryVariables>(
    query,
    options,
  )
}
